import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

export default function ItemForm() {

    const categories = [
        'Books',
        'Electronics',
        'Sports Equipment',
        'Clothing & Accessories',
        'Home & Kitchen Appliances',
        'Furniture',
        'Toys & Games',
        'Musical Instruments',
        'Tools & Equipment',
        'Outdoor Gear',
        'Arts & Crafts Supplies',
        'Beauty & Personal Care Products',
        'Health & Fitness Gear',
        'Stationery & Office Supplies',
        'Collectibles & Memorabilia'
    ];

    const [formData, setFormData] = useState({
        title: '',
        category: '',
        description: '',
        price: 0,
        condition: 'New',
        status: 'Available',
        ownerName: '',
        ownerRollNo: '',
        ownerRoomNo: '',
        imageUrl: '',
        location: '',
    });

    useEffect(() => {
        const userDataString = localStorage.getItem('userData');
        if (userDataString) {
            const userData = JSON.parse(userDataString);
            setFormData((prevFormData) => ({
                ...prevFormData,
                ownerName: userData.name || '',
                ownerRollNo: userData.studentId || '',
                ownerRoomNo: userData.hostelRoomNo || '',
            }));
        }
    }, []);

    const handleChange = (e) => {
        const { name, value, type } = e.target;
        const newValue = type === 'file' ? e.target.files[0] : value;

        if (type === 'file') {
            const reader = new FileReader();
            reader.onload = () => {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    imageUrl: reader.result, // Set the base64 string as imageUrl
                }));
            };
            reader.readAsDataURL(newValue);
        } else {
            setFormData({ ...formData, [name]: newValue });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Get userData from localStorage
            const userDataString = localStorage.getItem('userData');
            if (!userDataString) {
                throw new Error('User data not found in localStorage');
            }
            const userData = JSON.parse(userDataString);
            console.log(userData.authtoken);
            // Set authorization header with token from userData
            const headers = {
                Authorization: `${userData.authtoken}`,
                'Content-Type': 'application/json' // Set content type if needed
            };
    
            // Send POST request with headers and form data
            const response = await axios.post('https://backend-alien.vercel.app/api/main/items', formData, { headers });
            
            console.log(response.data); // Log the response data if needed
            if(response.data.status === 201){
                toast.success("Item Added Successfully")
            }
            else{
                toast.error("Error Adding Item")
            }
            // Handle success
        } catch (error) {
            console.error('Error submitting form:', error);
            // Handle error
        }
    };

    return (
        <div className="max-w-md mx-auto">
            <h2 className="text-2xl font-bold mb-4">Add New Item</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="title" className="block font-medium">Title</label>
                    <input
                        type="text"
                        id="title"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                        required
                    />
                </div>
                <div>
                    <label htmlFor="category" className="block font-medium">Category</label>
                    <select
                        id="category"
                        name="category"
                        value={formData.category}
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                        required
                    >
                        <option value="">Select a category</option>
                        {categories.map((category, index) => (
                            <option key={index} value={category}>{category}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label htmlFor="description" className="block font-medium">Description</label>
                    <textarea
                        id="description"
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                    />
                </div>
                <div>
                    <label htmlFor="price" className="block font-medium">Price</label>
                    <input
                        type="number"
                        id="price"
                        name="price"
                        value={formData.price}
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                        required
                    />
                </div>
                <div>
                    <label htmlFor="condition" className="block font-medium">Condition</label>
                    <select
                        id="condition"
                        name="condition"
                        value={formData.condition}
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                    >
                        <option value="New">New</option>
                        <option value="Used">Used</option>
                        <option value="Refurbished">Refurbished</option>
                        <option value="Like New">Like New</option>
                        <option value="Good">Good</option>
                        <option value="Fair">Fair</option>
                        <option value="Poor">Poor</option>
                    </select>
                </div>
                <div>
                    <label htmlFor="status" className="block font-medium">Status</label>
                    <select
                        id="status"
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                    >
                        <option value="Available">Available</option>
                        <option value="Unavailable">Unavailable</option>
                        <option value="Borrowed">Borrowed</option>
                        <option value="Sold">Sold</option>
                    </select>
                </div>
                <div>
                    <label htmlFor="ownerName" className="block font-medium">Owner Name</label>
                    <input
                        type="text"
                        id="ownerName"
                        name="ownerName"
                        value={formData.ownerName}
                        disabled
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                        required
                    />
                </div>
                <div>
                    <label htmlFor="ownerRollNo" className="block font-medium">Owner Roll No</label>
                    <input
                        type="text"
                        id="ownerRollNo"
                        name="ownerRollNo"
                        value={formData.ownerRollNo}
                        onChange={handleChange}
                        disabled
                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                        required
                    />
                </div>
                <div>
                    <label htmlFor="ownerRoomNo" className="block font-medium">Owner Room No</label>
                    <input
                        type="text"
                        id="ownerRoomNo"
                        name="ownerRoomNo"
                        value={formData.ownerRoomNo}
                        onChange={handleChange}
                        disabled
                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                        required
                    />
                </div>
                     <div>
                    <label htmlFor="image" className="block font-medium">Image</label>
                    <input
                        type="file"
                        id="image"
                        name="image"
                        accept="image/*"
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                        required
                    />
                </div>
                <div>
                    <label htmlFor="location" className="block font-medium">Location</label>
                    <input
                        type="text"
                        id="location"
                        name="location"
                        value={formData.location}
                        onChange={handleChange}
                        className="mt-1 p-2 border border-gray-300 rounded-md w-full"
                    />
                </div>
                <div>
                    <button
                        type="submit"
                        className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 focus:outline-none focus:bg-blue-600"
                    >
                        Submit
                    </button>
                </div>
            </form>
        </div>
    );
}
